import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { formatDateTime, formatRelativeTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { Loader, Grid, Table, Header, Flex, Icon } from 'nallian-shared-ui/lib/components';
import CopyToClipboard from '../../../app/components/CopyToClipboard';

const FeatureDetails = ({ feature, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Loader active inline="centered" />;
  }

  if (!feature) return <span>{t('noFeatureDetails')}</span>;

  return (
    <Grid columns={2} stackable>
      <Grid.Column>
        <Header>{t('general')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('name')}</Table.HeaderCell>
            <Table.Cell>{feature.name}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('description')}</Table.HeaderCell>
            <Table.Cell>{feature.description || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('tag')}</Table.HeaderCell>
            <Table.Cell>{feature.tag || '-'}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('isGlobal')}</Table.HeaderCell>
            <Table.Cell>
              <Icon
                name={feature.isGlobal ? 'checkmark' : 'minus'}
                color={feature.isGlobal ? 'green' : 'gray'}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('requiresSubscription')}</Table.HeaderCell>
            <Table.Cell>
              <Icon
                name={feature.requiresSubscription ? 'checkmark' : 'minus'}
                color={feature.requiresSubscription ? 'green' : 'gray'}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('isCrossCommunity')}</Table.HeaderCell>
            <Table.Cell>
              <Icon
                name={feature.isCrossCommunity ? 'checkmark' : 'minus'}
                color={feature.isCrossCommunity ? 'green' : 'gray'}
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('isObsolete')}</Table.HeaderCell>
            <Table.Cell>
              <Icon
                name={feature.isObsolete ? 'checkmark' : 'minus'}
                color={feature.isObsolete ? 'green' : 'gray'}
              />
            </Table.Cell>
          </Table.Row>
        </Table>
        <Header>{t('metaData')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('createdOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(feature.createdOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(feature.createdOn)}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>{t('lastModifiedOn')}</Table.HeaderCell>
            <Table.Cell>
              {`${formatDateTime(feature.modifiedOn)}`}
              &nbsp;-&nbsp;
              {formatRelativeTime(feature.modifiedOn)}
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
      <Grid.Column>
        <Header>{t('data')}</Header>
        <Table>
          <Table.Row>
            <Table.HeaderCell width={4}>{t('id')}</Table.HeaderCell>
            <Table.Cell>
              <Flex fluid alignItems="center" justifyContent="space-between">
                {feature.id}
                <CopyToClipboard value={feature.id} />
              </Flex>
            </Table.Cell>
          </Table.Row>
        </Table>
      </Grid.Column>
    </Grid>
  );
};

FeatureDetails.propTypes = {
  feature: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default FeatureDetails;
